// extracted by mini-css-extract-plugin
export default {"OrganizationDocumentsList":"OrganizationDocumentsList_OrganizationDocumentsList__7ETbV"};